var _excluded = ["value", "onChange", "options", "otherOptionLabel", "clearWhenOptionsUpdated"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState, useEffect, useRef, useMemo } from 'react';
import { RadioGroup } from './index';
import { TextArea } from '../input';
import { LocaleContext } from '../locale';
import { compareOptions, optionsHOC } from '../utils/option-utils';
var otherKey = 'iglooRadioGroupOther';

var InnerRadioGroupWithOther = function InnerRadioGroupWithOther(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      otherOptionLabel = _ref.otherOptionLabel,
      _ref$clearWhenOptions = _ref.clearWhenOptionsUpdated,
      clearWhenOptionsUpdated = _ref$clearWhenOptions === void 0 ? false : _ref$clearWhenOptions,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      otherEnabled = _useState2[0],
      enableOther = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var originOptions = useRef(options);
  useEffect(function () {
    typeof onChange === 'function' && value !== selected && onChange(selected);
  }, [selected]);
  useEffect(function () {
    setSelected(value);
  }, [value]);
  useEffect(function () {
    var setFieldValue = rest.setFieldValue;

    if (compareOptions(options, originOptions.current)) {
      if (clearWhenOptionsUpdated) {
        typeof setFieldValue === 'function' && setFieldValue();
      } else {
        var foundValue = options.find(function (option) {
          return Array.isArray(value) ? value.includes(option.value) : option.value === value;
        });

        if (!foundValue && value !== undefined) {
          typeof setFieldValue === 'function' && setFieldValue();
        }
      }

      originOptions.current = options;
    }
  }, [options]);

  var handleChange = function handleChange(e) {
    enableOther(true);
    onChange && onChange(e);
  };

  var handleRadioChange = function handleRadioChange(e) {
    enableOther(e.target.value === otherKey);
    onChange && onChange(e);
  };

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var otherValue = useMemo(function () {
    return value === otherKey ? '' : value;
  }, [value]);
  var optionValueList = useMemo(function () {
    return options.map(function (e) {
      return e.value;
    });
  }, [options]);
  var radioGroupValue = useMemo(function () {
    if (otherEnabled) return otherKey;
    if (optionValueList.includes(value) || value === undefined) return value;
    return otherKey;
  }, [options, otherEnabled, value]);
  return _jsx("div", {
    className: "igloo-reason-selector",
    children: _jsx(RadioGroup, _objectSpread({
      value: radioGroupValue,
      onChange: handleRadioChange,
      options: [].concat(_toConsumableArray(options), [{
        label: otherOptionLabel || formatMessage({
          id: 'Other Reason'
        }),
        value: otherKey,
        extraInfo: {
          content: _jsx(TextArea, {
            onChange: handleChange,
            value: otherValue
          }),
          shownTrigger: 'checked'
        }
      }])
    }, rest))
  });
};

var RadioGroupWithOther = optionsHOC(InnerRadioGroupWithOther);
RadioGroupWithOther.isPreviewSupport = true;
export default RadioGroupWithOther;